import React, { useEffect, useState } from "react";
import "../CSS/TopbarTenagaKesehatan.css";
import { FaBell, FaUserCircle } from "react-icons/fa";

function TopbarDetail() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUser(storedUser);
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-left">
        <h2 className="page-title">Data Pasien</h2>
      </div>

      {/* Jika user ada → tampilkan info user */}
      {user ? (
        <div className="user-info">
          <FaBell className="icon" />
          <div className="user-name">
            <p className="name">{user.username || user.nama || "User"}</p>
            <p className="role">{user.profesi || user.Profesi || "-"}</p>
          </div>
          <FaUserCircle className="profile-icon" />
        </div>
      ) : (
        // Jika user belum ada → fallback default
        <div className="user-info">
          <FaBell className="icon" />
          <div className="user-name">
            <p className="name">User</p>
            <p className="role">-</p>
          </div>
          <FaUserCircle className="profile-icon" />
        </div>
      )}
    </div>
  );
}

export default TopbarDetail;
